module.exports = __webpack_public_path__ + "static/retirement5-9d345de1227bc51c6c7b981af141affa.png";